import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { styled as muiStyled } from "@mui/system";
import { globalColors } from "../../Utils/colors";

export const GlobalRootContainer = muiStyled(Grid)({
  height: "100vh",
});

export const GlobalHeaderContainer = muiStyled(Grid)({
  height: "55px",
});

export const GlobalHeaderInnerGrid = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "55px",
  justifyContent: "space-between",
});

export const GlobalHeaderLogoTextContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "100%",
});

export const GlobalHeaderImageContainer = muiStyled(Grid)({
  alignItems: "center",
  backgroundColor: globalColors.logoBackground,
  color: globalColors.primaryTextColor,
  display: "flex",
  height: "100%",
  justifyContent: "center",
  width: "52px",
});

export const GlobalHeadingText = muiStyled("div")({
  fontFamily: "Poppins",
  fontSize: "18px",
  fontWeight: "600",
  margin: "0px 5px",
  color: globalColors.primaryTextColor,
});

export const GlobalBodyContainer = muiStyled(Grid)({
  height: "calc(100% - 55px)",
});

export const GlobalSidebarContainer = muiStyled(Grid, {
  shouldForwardProp: (prop) => prop !== "isCollapsed",
})<{ isCollapsed?: boolean }>((theme: any) => ({
  height: "100%",
  width: theme.isCollapsed ? "52px" : "280px",
  transition: "width 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
  overflow: "hidden",
  flexShrink: 0,
}));

export const GlobalSidebarRootContainer = muiStyled(Grid, {
  shouldForwardProp: (prop) => prop !== "isCollapsed",
})<{ isCollapsed?: boolean }>((theme: any) => ({
  height: "100%",
  width: "100%",
  backgroundColor: globalColors.backgroundLightGrey,
  overflow: "hidden",
}));

export const GlobalSidebarHeaderContainer = muiStyled(Grid, {
  shouldForwardProp: (prop) => prop !== "isCollapsed",
})<{ isCollapsed?: boolean }>((theme: any) => ({
  height: "60px",
  width: "100%",
  color: globalColors.headingBlack,
  fontFamily: "Poppins",
  fontSize: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: theme.isCollapsed ? "center" : "space-between",
  paddingLeft: theme.isCollapsed ? "0px" : "20px",
  paddingRight: theme.isCollapsed ? "0px" : "8px",
  fontWeight: "600",
}));

export const CardContainer = muiStyled(Box, {
  shouldForwardProp: (prop) => prop !== "bgColor",
})<{ bgColor?: String }>(
  (theme: any) => ({
    backgroundColor: theme.bgColor,
    borderRadius: "10px",
    minHeight: "110px",
    margin: "15px 0px",
  })
);

export const GlobalSidebarRowContainer = muiStyled(Grid, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isDisabled" && prop !== "isCollapsed",
})<{
  isSelected?: Boolean;
  isDisabled?: Boolean;
  isCollapsed?: Boolean;
}>((theme: any) => ({
  height: "40px",
  width: "100%",
  fontFamily: "Poppins",
  fontSize: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: theme.isCollapsed ? "center" : "space-between",
  paddingLeft: theme.isCollapsed ? "0px" : "20px",
  paddingRight: theme.isCollapsed ? "0px" : "15px",
  cursor: theme.isDisabled ? "unset" : "pointer",
  borderBottom: `1px solid ${globalColors.white}`,
  backgroundColor: theme.isSelected ? globalColors.backgroundGrey : "unset",
  color: theme.isSelected ? globalColors.calmLightDark : globalColors.textGrey,
  userSelect: "none",

  "&:hover": {
    backgroundColor: theme.isDisabled
      ? "unset"
      : theme.isSelected
        ? globalColors.white
        : globalColors.hoverColor,
  },
}));

export const GlobalSidebarIconTextContainer = muiStyled(Grid)({
  height: "100%",
  display: "flex",
  alignItems: "center",
});

export const GlobalContentContainer = muiStyled(Grid, {
  shouldForwardProp: (prop) => prop !== "isCollapsed",
})<{ isCollapsed?: boolean }>((theme: any) => ({
  height: "100%",
  width: theme.isCollapsed ? "calc(100% - 52px)" : "calc(100% - 280px)",
  transition: "width 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
}));

export const GlobalHeaderAvatarContainer = muiStyled(Avatar)({
  marginRight: "5px",
  height: "32px",
  width: "32px",
});

export const RootContainer = muiStyled(Box)({
  backgroundColor: globalColors.backgroundGrey,
  height: "100%",
  overflow: "hidden",
  padding: "15px 30px",
});

export const HeaderContainer = muiStyled(Box, {
  shouldForwardProp: (prop) => prop !== "isSmallScreen" && prop !== "isListEmpty",
})<{
  isSmallScreen?: Boolean;
  isListEmpty: Boolean;
}>((theme: any) => ({
  marginBottom: "15px",
  minHeight: theme.isListEmpty ? "50px" : theme.isSmallScreen ? "145px" : "100px",
  height: "auto",
}));

export const HeaderTitleContainer = muiStyled("div", {
  shouldForwardProp: (prop) => prop !== "isSmallScreen",
})<{
  isSmallScreen?: Boolean;
}>((theme: any) => ({
  color: globalColors.primaryTextColor,
  fontFamily: "Poppins",
  fontSize: "32px",
  fontWeight: "600",
  height: "50px",
  textAlign: "initial",
  marginBottom: theme.isSmallScreen ? "5px" : "0px",
}));

export const LabelContainer = muiStyled(Box)({
  fontFamily: "Poppins",
  fontSize: "14px",
  marginRight: 10,
});

export const HeaderActionsContainer = muiStyled(Box)({
  minHeight: "50px",
  height: "auto",
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
});

export const BodyContainer = muiStyled(Box, {
  shouldForwardProp: (prop) => prop !== "isSmallScreen" && prop !== "isListEmpty" && prop !== "isListSearchActive",
})<{
  isSmallScreen?: Boolean;
  isListEmpty: Boolean;
  isListSearchActive: Boolean;
}>((theme: any) => ({
  overflowY: "auto",
  backgroundColor: globalColors.backgroundGrey,
  height: theme.isListSearchActive
    ? "calc(100% - 125px)"
    : theme.isListEmpty
      ? "calc(100% - 115px)"
      : theme.isSmallScreen
        ? "calc(100% - 160px)"
        : "calc(100% - 115px)",
  marginTop: theme.isListEmpty ? "70px" : "0px",
}));

export const FilterBoxContainer = muiStyled(Box, {
  shouldForwardProp: (prop) => prop !== "marginRightSpace",
})<{ marginRightSpace?: string }>(
  (theme: any) => ({
    alignItems: "center",
    display: "flex",
    marginRight: theme.marginRightSpace,
  })
);

export const SearchBoxContainer = muiStyled(Box, {
  shouldForwardProp: (prop) => prop !== "isSmallScreen",
})<{ isSmallScreen?: Boolean }>(
  (theme: any) => ({
    alignItems: "center",
    display: "flex",
    marginTop: theme.isSmallScreen ? "10px" : "0px",
    width: theme.isSmallScreen ? "100%" : "unset",
  })
);

export const ActionsGridContainer = muiStyled(Grid)({
  alignItems: "center",
  display: "flex",
  height: "auto",
  minHeight: "50px",
  width: "calc(100% - 175px)",
  flexWrap: "wrap",
  gap: "12px",
});

export const CreateNewButtonContainer = muiStyled(Grid, {
  shouldForwardProp: (prop) => prop !== "isSmallScreen",
})<{
  isSmallScreen?: Boolean;
}>((theme: any) => ({
  alignItems: theme.isSmallScreen ? "flex-start" : "center",
  display: "flex",
  height: "auto",
  minHeight: "50px",
  width: "175px",
}));

export const AltImage = muiStyled("div")({
  height: 200
});
